import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import {map} from 'lodash';
import ProductDetailsImage from './image';
import ProductDetailsInfo from './info';
import { nodeAttrs, getElementsByClassName, getElementById } from '../../../utils/dom';

const Y_POSITIONS = {
  INITIAL: null,
  BOTTOM: 'bottom',
  FLOATING: 'floating'
};

const SCROLL_BOTTOM_MARGIN = 100;
const PRODUCT_INFO_ID = 'product-details-information';
const PRODUCT_IMAGES_ID = 'product-details-images';

export const imageContainerIsTallerThanText = (imagesRef, textRef) =>
  nodeAttrs(imagesRef).clientHeight > nodeAttrs(textRef).clientHeight;

export default class ProductDetailsVerticalScrollImages extends Component {
  state = {
    yPosition: Y_POSITIONS.INITIAL
  };

  componentDidMount() {
    const imageContainer = getElementById(PRODUCT_IMAGES_ID, document);
    const textContainer = getElementById(PRODUCT_INFO_ID, document);

    if (imageContainerIsTallerThanText(imageContainer, textContainer)) {
      window.addEventListener('scroll', this.handleScroll);
    }

    this.addActiveClassToIcons(0);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  getNewYPosition() {
    const { bottom: parentBottom } = nodeAttrs(getElementById(this.props.parentElementID, document));
    const productTextHeight = nodeAttrs(getElementById(PRODUCT_INFO_ID, document)).clientHeight;

    const scrolledBelowFloatArea = (
      parentBottom - productTextHeight <= SCROLL_BOTTOM_MARGIN
    );

    if (scrolledBelowFloatArea) {
      return Y_POSITIONS.BOTTOM;
    }

    return Y_POSITIONS.FLOATING;
  }

  handleScroll = () => {
    const newYPosition = this.getNewYPosition();

    if (this.state.yPosition !== newYPosition) {
      this.setState({
        yPosition: newYPosition
      });
    }
  }

  addActiveClassToIcons = (displayOrder) => {
    const transitionIcons = getElementsByClassName('bullet', document);

    if (transitionIcons.length) {
      map(transitionIcons, transitionIcon => {
        if (transitionIcon.dataset.id === displayOrder.toString()) {
          transitionIcon.classList.add('active');
        }
      });
    }
  }

  removeActiveClassFromIcons = (displayOrder) => {
    const transitionIcons = getElementsByClassName('bullet', document);

    map(transitionIcons, transitionIcon => {
      if (transitionIcon.dataset.id === displayOrder.toString()) {
        transitionIcon.classList.remove('active');
      }
    });
  }

  render() {
    const { images } = this.props.product;
    const className = classNames('image-text-wrapper', this.state.yPosition);

    return (
      <div className={className}>
        <div className="pd-image-transition-icons">
          {
            images.length > 1 && map(images, ({ display_order }) => (
              <div key={display_order}
                data-id={display_order}
                className="bullet"
              />
            ))
          }
        </div>
        <div id={PRODUCT_IMAGES_ID}>
          {
            map(images, ({ display_order, url }) => (
              <ProductDetailsImage key={display_order}
                imageURL={url}
                displayOrder={display_order}
                addActiveClassToIcons={this.addActiveClassToIcons}
                removeActiveClassFromIcons={this.removeActiveClassFromIcons}
              />
            ))
          }
        </div>
        <ProductDetailsInfo {...this.props} id={PRODUCT_INFO_ID} />
      </div>
    );
  }
}

ProductDetailsVerticalScrollImages.propTypes = {
  parentElementID: PropTypes.string.isRequired,
  product: PropTypes.shape({
    id: PropTypes.number,
    brand: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    }),
    name: PropTypes.string.isRequired,
    product_url: PropTypes.string.isRequired,
    offer: PropTypes.shape({
      currency: PropTypes.string,
      price: PropTypes.number,
      sale_price: PropTypes.number,
      retailer: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string
      })
    }),
    images: PropTypes.array,
    description: PropTypes.string.isRequired,
    is_sponsored: PropTypes.bool,
    click_tracker: PropTypes.string,
    impression_tracker: PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.shape({
      truncated_short_title_80: PropTypes.string,
      url: PropTypes.string,
      label: PropTypes.string
    }))
  }),
  meta_data: PropTypes.shape({
    meta_title: PropTypes.string,
    meta_description: PropTypes.string
  }),
  analytics: PropTypes.shape({
    url_full: PropTypes.string
  }),
  shoppingNavigation: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        path: PropTypes.string
      })
    )
  })
};
